export const enforceTermsOnCompetitionForm = function(formElement,customErrorMessage = null) {
    if (!formElement) {
      return;
    }
  
    const termsInput: any = formElement.querySelector("#terms,.terms");
  
    if (formElement && termsInput) {

      const errorElement = document.createElement("span");
      errorElement.classList.add("field-validation-error");
      errorElement.textContent = customErrorMessage == null 
      ? "You must agree to the Privacy Collection Statement and Competition Terms and Conditions to enter." 
      : customErrorMessage;
      //append error element
      termsInput.parentNode.appendChild(errorElement);

      termsInput.addEventListener("change", (event: any) => {
        if (event.target.checked) {
          errorElement.style.display = "none";
        } else {
          errorElement.style.display = "block";
        }
      });
  
      formElement.addEventListener("submit", (event: any) => {
        if (!termsInput.checked) {
          event.preventDefault();
          errorElement.style.display = "block";
        }
      });
    }
  };